var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("div", [
    _vm.type === "MX"
      ? _c("p", [
          _c(
            "b",
            {
              class: {
                "grey--text text--darken-4": !_vm.model.domain
              }
            },
            [_vm._v(_vm._s(_vm.model.domain || "Name"))]
          ),
          _vm._v(" will point to "),
          _c(
            "b",
            {
              class: {
                "grey--text text--darken-4": !_vm.model.exchanger
              }
            },
            [_vm._v(_vm._s(_vm.model.exchanger || "Destination"))]
          )
        ])
      : _vm.type === "A" || _vm.type === "AAAA"
      ? _c("p", [
          _c(
            "b",
            {
              class: {
                "grey--text text--darken-4": !_vm.model.name
              }
            },
            [
              _vm._v(
                _vm._s(_vm.model.name || "Name") + "." + _vm._s(_vm.domain)
              )
            ]
          ),
          _vm._v(" will point to "),
          _c(
            "b",
            {
              class: {
                "grey--text text--darken-4": !_vm.model.address
              }
            },
            [_vm._v(_vm._s(_vm.model.address || "IP Address"))]
          )
        ])
      : _vm.type === "CNAME"
      ? _c("p", [
          _c(
            "b",
            {
              class: {
                "grey--text text--darken-4": !_vm.model.name
              }
            },
            [
              _vm._v(
                _vm._s(_vm.model.name || "Name") + "." + _vm._s(_vm.domain)
              )
            ]
          ),
          _vm._v(" will point to "),
          _c(
            "b",
            {
              class: {
                "grey--text text--darken-4": !_vm.model.cname
              }
            },
            [_vm._v(_vm._s(_vm.model.cname || "Canonical Name"))]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }